var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from 'react';
import { TrTag } from '../../Utils/AtomicTag';
import { TableCell } from './TableCell';
import { connect } from 'mini-store';
var TableRow = /** @class */ (function (_super) {
    __extends(TableRow, _super);
    function TableRow(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {};
        return _this;
    }
    TableRow.getDerivedStateFromProps = function (nextProps, prevState) {
        if (prevState.visible || (!prevState.visible && nextProps.visible)) {
            // 点击第一次展开或页面加载
            return {
                shouldRender: true,
                visible: nextProps.visible,
            };
        }
        return {
            visible: nextProps.visible,
        };
    };
    TableRow.prototype.render = function () {
        if (!this.state.shouldRender) {
            return null;
        }
        var _a = this.props, record = _a.record, columns = _a.columns, index = _a.index, className = _a.className, rowKey = _a.rowKey, visible = _a.visible, height = _a.height, renderExpandIcon = _a.renderExpandIcon, renderExpandIconCell = _a.renderExpandIconCell, hasExpandIcon = _a.hasExpandIcon;
        var trClassName = className || '';
        var trStyle = {
            height: height,
        };
        if (!visible) {
            trStyle.display = 'none';
        }
        var cells = [];
        renderExpandIconCell(cells);
        for (var i = 0; i < columns.length; i += 1) {
            var column = columns[i];
            cells.push(React.createElement(TableCell, { record: record, column: column, key: column.key || column.dataIndex, index: index, expandIcon: hasExpandIcon(i) && renderExpandIcon() }));
        }
        return (React.createElement(TrTag, { className: trClassName, "data-row-key": rowKey, style: trStyle, autoPrefixedClassName: "table-row" }, cells));
    };
    TableRow.defaultProps = {
        hasExpandIcon: function () { },
        renderExpandIconCell: function () { },
    };
    return TableRow;
}(Component));
function getRowHeight(state, props) {
    var fixedColumnsBodyRowsHeight = state.fixedColumnsBodyRowsHeight;
    var fixed = props.fixed, rowKey = props.rowKey;
    if (!fixed) {
        return null;
    }
    if (fixedColumnsBodyRowsHeight[rowKey]) {
        return fixedColumnsBodyRowsHeight[rowKey];
    }
    return null;
}
export default connect(function (state, props) {
    var _a = state.expandedRowKeys, expandedRowKeys = _a === void 0 ? [] : _a;
    var ancestorKeys = props.ancestorKeys;
    // expandedRowKeys 表示所有展开行的 rowkey 集合
    // TODO ancestorKeys.length === 0
    var visible = ancestorKeys.length === 0 || ancestorKeys.every(function (k) { return expandedRowKeys.includes(k); });
    return {
        height: getRowHeight(state, props),
        visible: visible,
    };
})(TableRow);
